import {takeLatest} from "redux-saga/effects";
import * as ActionsTypes from "../../../../common/constants/stateConstants";
import {
    deletePackageSaga,
    excelExportPackageSaga,
    getConsultationPackagesListSaga,
    getHistoriquePackageSaga,
} from "./consultationPackagesSaga";

export default function* consultationPackagesWatcher() {
  yield takeLatest(
    ActionsTypes.GET_CONSULTATION_PACKAGES_LIST,
    getConsultationPackagesListSaga
  );
  yield takeLatest(
    ActionsTypes.GET_HISTORIQUE_PACKAGE,
    getHistoriquePackageSaga
  );
  yield takeLatest(ActionsTypes.DELETE_PACKAGE, deletePackageSaga);
  yield takeLatest(
    ActionsTypes.GENERAL_EXCEL_PACKAGE_EXPORT,
    excelExportPackageSaga);
}
